module.exports = __webpack_public_path__ + "img/open_group.b9f0b195.jpg";